



import aws_exports from "../aws-exports";
import Amplify, { API } from "aws-amplify";


Amplify.configure(aws_exports, {});




export default  function DownloadPdf(s3Path) {
  // let thePath = '4423/202503281413_go20Combined.pdf';
 
 let apiName = "vakicloudRdsAPI";
 let path = "/getFile/Signed";
 

 let myInit = {
   // OPTIONAL
   headers: {}, // OPTIONAL
   response: false, // OPTIONAL (return the entire Axios response object instead of only response.data)
   queryStringParameters: {
     // OPTIONAL
     PathPdf: s3Path
   }
 };
 
 
 
 
 
 API.get(apiName, path, myInit).then(response => {
  


  fetch(response.urlPdf)
      .then(res => {
        if (!res.ok) {
          throw new Error(`Download failed: ${res.status} ${res.statusText}`);
        }
        return res.blob();
      })
      .then(blob => {
        // Create a link from the Blob and trigger download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = s3Path.replace ("/", "_");  // Suggest filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(err => {
        console.error("Error downloading file:", err);
        alert("File not found or could not be downloaded.");
      });
 
 }).catch (err => {console.log ("Error fetching signed: "+err)});
   }
 




/*
export default  function DownloadPdf(s3Path) {
   // let thePath = '4423/202503281413_go20Combined.pdf';
  
  let apiName = "vakicloudRdsAPI";
  let path = "/getFile/Signed";
  

  let myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
    response: false, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: {
      // OPTIONAL
      PathPdf: s3Path
    }
  };
  
  
  
  
  
  API.get(apiName, path, myInit).then(response => {
   
            const link = document.createElement('a');
            link.href = response.urlPdf;
            link.download = 'your-file.pdf';  // Suggest filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
  
  }).catch (err => {console.log ("Error fetching signed: "+err)});
    }
  

*/
  
  